// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1vmTI","label":"Header_label__2ndLk","progress_container":"Header_progress_container__3fmPY","actions":"Header_actions__25E7D"};